<template>
  <q-list
    v-if="loading"
    separator
  >
    <q-item
      v-for="i in 5"
      :key="i"
      class="module-item"
    >
      <q-item-section>
        <div class="flex full-width no-wrap items-center">
          <q-skeleton
            type="text"
            animation="fade"
            style="flex: 0 1 300px"
          />
        </div>
        <div class="flex full-width no-wrap items-center">
          <q-skeleton
            type="text"
            animation="fade"
            style="flex: 0 1 150px"
            height="15px"
          />
        </div>
      </q-item-section>
    </q-item>
  </q-list>

  <div
    v-else-if="filteredForms.length > 0"
    class="form-list"
  >
    <div
      v-for="(group, categoryRef, index) in formattedForms"
      :key="categoryRef"
      :class="{'q-pt-md': index === 0, 'q-pt-sm': index > 0}"
    >
      <slot
        name="group"
        :anchor="anchor"
        :group="group"
        :index="index"
      >
        <sticky-header :anchor="anchor" color="black">
          {{ group.title }}
        </sticky-header>
      </slot>

      <q-list
        padding
        separator
        class="separator-end"
      >
        <slot
          v-for="(form, refKey) in group.forms"
          name="form"
          :form="form"
          :ref-key="refKey"
        />
      </q-list>
    </div>
  </div>

  <div v-else>
    <slot name="no-results">
      <no-results
        align="left"
        without-icon
        title="No templates to display"
      />
    </slot>
  </div>
</template>

<script>
import { groupFormsByCategory, matchFormsByReference, defaultGroup } from 'components/app/forms/partials/list/revisionsGroupMixin'
import { convertToReferenceNumber } from 'src/helpers/globals'

export default {
  props: {
    // Filtered forms to display on the list
    filteredForms: {
      type: Array,
      default: () => {
        return []
      }
    },
    // Turn off displaying custom groups at top of array
    displayCustomGroups: {
      type: Boolean,
      default: false
    },
    // Bind a custom set of forms to the top of the array
    customGroups: {
      type: Array,
      default: () => {
        return []
      }
    },
    anchor: {
      type: String,
      default: 'page'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedForms () {
      const formSet = {}
      if (this.displayCustomGroups) {
        for (const customGroup of this.customGroups) {
          const customGroupRef = convertToReferenceNumber(`__${customGroup.title}`)
          const forms = matchFormsByReference(this.filteredForms, customGroup.reference_ids, true)

          // If the custom group contains forms locally, then bind the group
          if (customGroup.reference_ids.length > 0 && Object.keys(forms).length > 0) {
            formSet[customGroupRef] = defaultGroup(customGroup.title, forms)
          }
        }
      }

      return {
        ...formSet,
        ...groupFormsByCategory(this.filteredForms)
      }
    }
  }
}
</script>

<style lang="scss">
.form-list {
  .form-group {
    overflow: hidden;
    transition: padding 0.25s ease;

    &:not(.without-border) .form-group-header,
    &:not(.without-border) .form-revision {
      border-right: 8px solid $blue-grey-1;
    }

    .form-group-header {
      &.contains-draft {
        border-right-color: $blue-grey-5;
        background-color: $blue-grey-1;
      }

      &.update-available {
        border-right-color: $orange-9;
        background-color: $orange-1 !important;
      }
    }

    .form-revision {
      &.draft {
        border-right-color: $blue-grey-5;
        background-color: $blue-grey-1;
      }

      &.archived {
        border-right-color: $red-7;
        background-color: $red-1;
      }

      &.update-available {
        border-right-color: $orange-9;
        background-color: $orange-1;
      }
    }
  }
}
</style>
